import { IYmlConstants } from "@/shared/model/global/yml-constants.model";
import axios from "axios";

const baseApiUrl = "api/global";

export default class GlobalService {
  public editClient(client): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/edit-client`, client)
        .then(function (res) {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public changePassword(entity): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("api/account/change-password", entity)
        .then(function (res) {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public parseContactsFile(file: any) {
    return new Promise<String>(function (resolve, reject) {
      axios
        .post(`${baseApiUrl}/parse-contacts-file`, file)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  public importContacts(contacts) {
    return new Promise<String>(function (resolve, reject) {
      axios
        .post(`${baseApiUrl}/import-contacts`, contacts)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  public downloadImportExample() {
    return new Promise<String>(function (resolve, reject) {
      axios
        .get(`${baseApiUrl}/download-import-example`)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  public getYmlConstants() {
    return new Promise<IYmlConstants>(function (resolve, reject) {
      axios
        .get(`${baseApiUrl}/get-yml-constants`)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }
}
